module.exports = __webpack_public_path__ + "img/idea_03.7c1dd9cf.png";